/** @format */
import {
    MarketCode,
    MarketIso,
    euMarket,
    europeanMarkets,
} from '@toucan/client/global/market';

import { searchClient } from './client';
import { getContentLanguage } from './helpers';
import { getSearchQueryParams } from './search-service';
import { Query, QueryResponse, SearchListingModel } from './types';

export async function getSearchResults<T>(
    search: Query,
    locale: MarketIso,
    marketCode: MarketCode
): Promise<QueryResponse<T>> {
    const results = await fetchSearchResults(
        '/product/query',
        search,
        locale,
        marketCode
    );

    return results;
}

export async function getSemanticSearchResults(
    search: Query,
    locale: MarketIso,
    marketCode: MarketCode
): Promise<QueryResponse<SearchListingModel>> {
    const results = await fetchSearchResults(
        '/product/semantic-query',
        search,
        locale,
        marketCode
    );

    return results;
}

async function fetchSearchResults(
    path: string,
    search: Query,
    locale: MarketIso,
    marketCode: MarketCode
) {
    // TODO - update when modelOperation is added to search-service
    // overrides the product/model (sets to EU) market for EU markets only.
    if (europeanMarkets.includes(marketCode)) {
        if (search?.filterQuery?.productMarket) {
            search.filterQuery.productMarket = euMarket.code;
        }

        if (search?.filterQuery?.modelMarket) {
            search.filterQuery.modelMarket = euMarket.code;
        }
    }

    const queryParams = getSearchQueryParams(search, marketCode);
    const contentLanguage = getContentLanguage(locale);

    const response = await searchClient.get(`${path}/?${queryParams}`, {
        headers: {
            'Content-Language': contentLanguage,
        },
    });

    return response.data;
}
